<template>
<!-- 要区分维修、非维修 -->
  <div class="inquiry-detail">
    <content-block title="维修设备信息">
      <el-descriptions :column="3">
        <el-descriptions-item label="设备名称">{{ info.deviceName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="设备型号">{{ info.deviceModel || '--' }}</el-descriptions-item>
        <el-descriptions-item label="设备品牌">{{ info.deviceBrandName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="故障描述" :span="3">{{ info.faultDescription || '--' }}</el-descriptions-item>
        <el-descriptions-item label="故障图片" :span="3">
          <template v-if="info.faultImageList && info.faultImageList.length">
            <el-image
              :preview-src-list="(info.faultImageList || []).map(i => i.url)"
              v-for="(img, index) in info.faultImageList" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
          </template>
        </el-descriptions-item>
      </el-descriptions>
    </content-block>
    <content-block title="物流信息">
      <el-radio-group v-model="tabPosition" style="margin-bottom: 16px;">
        <el-radio-button label="1">备用机寄出信息</el-radio-button>
        <el-radio-button label="2">备用机寄出签收信息</el-radio-button>
        <el-radio-button label="3">备用机寄回信息</el-radio-button>
        <el-radio-button label="4">备用机寄回签收信息</el-radio-button>
      </el-radio-group>
      <el-descriptions v-if="tabPosition === '1'" :column="3">
        <el-descriptions-item label="供应商" :span="3">{{ formatData(info, 'tenantName') }}</el-descriptions-item>
        <el-descriptions-item label="快递公司">{{ formatData(info.spareSendOutDTO, 'courierName') }}</el-descriptions-item>
        <el-descriptions-item label="快递单号" :span="2"><span style="color: #237FFA; cursor: pointer;" @click="() => showLogisticDetail('spareSendOutDTO')">{{ formatData(info.spareSendOutDTO, 'courierNumber') }}{{ getLogisticNode('spareSendOutDTO') }}</span></el-descriptions-item>
        <el-descriptions-item label="寄出设备图片" :span="3">
            <el-image
              :preview-src-list="getImageList(info.spareSendOutDTO, 'deviceAnnexList').map(i => i.url)"
              v-for="(img, index) in getImageList(info.spareSendOutDTO, 'deviceAnnexList')" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="寄出包装图片" :span="3">
            <el-image
              :preview-src-list="getImageList(info.spareSendOutDTO, 'wrapAnnexList').map(i => i.url)"
              v-for="(img, index) in getImageList(info.spareSendOutDTO, 'wrapAnnexList')" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-if="tabPosition === '2'" :column="3">
        <el-descriptions-item label="签收备注" :span="3">{{ formatData(info.spareSendOutSignDTO, 'remark') }}</el-descriptions-item>
        <el-descriptions-item label="备用机签收图片" :span="3">
            <el-image
              :preview-src-list="getImageList(info.spareSendOutSignDTO, 'deviceAnnexList').map(i => i.url)"
              v-for="(img, index) in getImageList(info.spareSendOutSignDTO, 'deviceAnnexList')" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="备用机包装图片" :span="3">
            <el-image
              :preview-src-list="getImageList(info.spareSendOutSignDTO, 'wrapAnnexList').map(i => i.url)"
              v-for="(img, index) in getImageList(info.spareSendOutSignDTO, 'wrapAnnexList')" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-if="tabPosition === '3'" :column="3">
        <el-descriptions-item label="快递公司">{{ formatData(info.spareSendBackDTO, 'courierName') }}</el-descriptions-item>
        <el-descriptions-item label="快递单号" :span="2"><span style="color: #237FFA; cursor: pointer;" @click="() => showLogisticDetail('spareSendBackDTO')">{{ formatData(info.spareSendBackDTO, 'courierNumber') }}{{ getLogisticNode('spareSendBackDTO') }}</span></el-descriptions-item>
        <el-descriptions-item label="寄回备注" :span="3">{{ formatData(info.spareSendBackDTO, 'remark') }}</el-descriptions-item>
        <el-descriptions-item label="寄回设备图片" :span="3">
            <el-image
              :preview-src-list="getImageList(info.spareSendBackDTO, 'deviceAnnexList').map(i => i.url)"
              v-for="(img, index) in getImageList(info.spareSendBackDTO, 'deviceAnnexList')" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="寄回包装图片" :span="3">
            <el-image
              :preview-src-list="getImageList(info.spareSendBackDTO, 'wrapAnnexList').map(i => i.url)"
              v-for="(img, index) in getImageList(info.spareSendBackDTO, 'wrapAnnexList')" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-if="tabPosition === '4'" :column="3">
        <el-descriptions-item label="外包装情况">{{ formatData(info.spareSendBackSignDTO, 'wrapFlagMsg') }}</el-descriptions-item>
        <el-descriptions-item label="设备外观" :span="2">{{ formatData(info.spareSendBackSignDTO, 'facadeFlagMsg') }}</el-descriptions-item>
        <el-descriptions-item label="签收备注" :span="3">{{ formatData(info.spareSendBackSignDTO, 'remark') }}</el-descriptions-item>
        <el-descriptions-item label="签收设备图片" :span="3">
            <el-image
              :preview-src-list="getImageList(info.spareSendBackSignDTO, 'deviceAnnexList').map(i => i.url)"
              v-for="(img, index) in getImageList(info.spareSendBackSignDTO, 'deviceAnnexList')" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="签收包装图片" :span="3">
            <el-image
              :preview-src-list="getImageList(info.spareSendBackSignDTO, 'wrapAnnexList').map(i => i.url)"
              v-for="(img, index) in getImageList(info.spareSendBackSignDTO, 'wrapAnnexList')" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
        </el-descriptions-item>
      </el-descriptions>
    </content-block>
    <ExpressDetailDialog ref="expressDetailDialog"></ExpressDetailDialog>
  </div>
</template>
<script>
import ExpressDetailDialog from '../../components/expressDetailDialog.vue';

export default {
  components: {
    ExpressDetailDialog,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      tabPosition: '1',
    };
  },
  methods: {
    formatData (obj, key) {
      return obj?.[key] ? obj[key] : '--';
    },
    getImageList (obj, key) {
      return !obj || !obj[key] ? [] : obj[key];
    },
    getLogisticNode (key) {
      const courierNumber = this.info?.[key]?.courierNumber;
      let ret = '';

      if (courierNumber) {
        const logistics = this.info[key].logisticsTrackList;

        if (logistics && logistics.length) {
          ret = logistics[0].status ? `_${logistics[0].status}` : '';
        }
      }

      return ret;
    },
    showLogisticDetail (key) {
      const courierNumber = this.info?.[key]?.courierNumber;

      if (courierNumber) {
        const courierName = this.info?.[key]?.courierName;
        const logisticTracks = this.info?.[key]?.logisticsTrackList;

        this.$refs.expressDetailDialog.init(courierName || '', courierNumber || '', logisticTracks || []);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.inquiry-detail {
  .long-text {
    width: 95%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
